import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import ReactToPrint from 'react-to-print';

import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';
import { fetchEmployeeData } from '../../../Store/PHPSlice/Employee';
import { selectEmployees } from '../../Selectors/Master/ItemSelectors';



const EmpDepartView = () => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({});
    const dispatch = useDispatch();
    const emplist = useSelector(selectEmployees);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef();
    useEffect(() => {
        dispatch(fetchEmployeeData(Id))
    }, [Id, dispatch]);

    useEffect(() => {
        if (emplist?.data) {
            setFormData(emplist?.data);
        }
    }, [emplist]);

    // console.log(formData);
    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };
    // console.log(emplist)

    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>
                        {/* {formData?.firmId !== '' && <FirmHeaderImg firmId={formData.firmId} />} */}
                        <h3 className='centered-heading'>Employee Department View</h3>
                        <div className="dashed-line"></div>

                        <h4>Employee : {formData.empNm}</h4>


                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Category</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Department</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {emplist?.info?.map((row, index) => (
                                        <TableRow key={index}>

                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {index + 1}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.categoryNm}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.departNm}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>


                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>

                </Paper>
            </Grid>
        </>
    );
};

export default EmpDepartView;
